import { Typography, TypographyProps } from '@material-ui/core'

import React from 'react'

const TableTitle = (props: TypographyProps) => (
  <Typography color="secondary" variant="h6" {...props} />
)

export default TableTitle
